'use client'
// AI generated

import { ReactFlowProvider } from '@xyflow/react'
import type { RenderElementProps } from 'slate-react'
import { useReadOnly } from 'slate-react'
import { twMerge } from 'tailwind-merge'
import type { FlowElement } from '..'
import { DEFAULT_FLOW_HEIGHT, MAX_FLOW_HEIGHT } from '../constants'
import { useFlowHeight } from '../hooks/useFlowHeight'
import FlowCanvas from './FlowCanvas'

type FlowProps = RenderElementProps & { element: FlowElement }

export default function Flow({ attributes, children, element }: FlowProps) {
  const readonly = useReadOnly()
  const containerRef = useFlowHeight(element)

  return (
    <div {...attributes}>
      <div
        ref={containerRef}
        contentEditable={false}
        className={twMerge(
          'tbf-flow w-full overflow-auto border-2',
          !readonly && 'resize-y',
        )}
        style={{
          height: element.height || DEFAULT_FLOW_HEIGHT,
          minHeight: DEFAULT_FLOW_HEIGHT,
          maxHeight: MAX_FLOW_HEIGHT,
        }}
      >
        <ReactFlowProvider>
          <FlowCanvas element={element} />
        </ReactFlowProvider>
      </div>
      {children}
    </div>
  )
}
